import * as Sentry from '@sentry/react';
import SentryRRWeb from '@sentry/rrweb';
import { BrowserTracing } from '@sentry/tracing';
import _ from 'lodash';
import { createBrowserHistory } from 'history';

function initSentry() {
  if (process.env.NODE_ENV !== 'production') return;

  const { enableSentry, sentryDsn, env } = window.__config__;
  if (enableSentry) {
    const dsn = process.env.SENTRY_DSN || sentryDsn;
    const maxLength = 500;
    const history = createBrowserHistory();

    Sentry.init(
      !dsn
        ? // 兼容老版本sentry
          {
            dsn: 'https://9e4ea97522ee40d896607d7be1f3f788:842bee8963664450b4e978ac6adddd23@sentry.miotech.com/14',
          }
        : {
            dsn,
            environment: env,
            integrations: [
              new SentryRRWeb({
                maskAllInputs: false,
              }),
              new BrowserTracing({
                routingInstrumentation:
                  Sentry.reactRouterV5Instrumentation(history),
                _metricOptions: {
                  _reportAllChanges: true,
                },
                idleTimeout: 5000,
              }),
            ],
            beforeBreadcrumb: (breadcrumb: any, hint: any) => {
              if (breadcrumb.category === 'xhr') {
                return {
                  ...breadcrumb,
                  data: {
                    ...breadcrumb.data,
                    requestBody: _.truncate(hint?.xhr.__sentry_xhr__.body, {
                      length: maxLength,
                    }),
                    response: _.truncate(hint?.xhr.response, {
                      length: maxLength,
                    }),
                  },
                };
              }
              return breadcrumb;
            },
            tracesSampleRate: 0.2,
          },
    );
  
    Sentry.addGlobalEventProcessor(event => {
      // Only target transaction events
      const { transaction } = event;
      const path = '/' + window.location.pathname.split('/')[1];
      if (transaction && !transaction.startsWith(path)) {
        event.transaction = path + transaction;
      }
      return event;
    });
  
    window.addEventListener('unhandledrejection', function onunhandledrejectionHandler(
      data: PromiseRejectionEvent,
    ) {
      Sentry.captureException(data.reason ?? new Error('unknown unhandledrejection error'));
    });
  }
}

initSentry();
